module.exports = ".ck-find-result{background:#fff700;color:var(--ck-color-text)}.ck-find-result_selected{background:#fd0}"